import { Default, Detail,  List, Create } from "./views";
import { ApplyAction } from "./wizards";



const Module = {
    name: "zohoorders",
    defaultRoutePath: "/zoho/order",
    menuItemScope: "sync",
    menuItemName: "zohoorders",

    routes: [
        {
            path: "/zoho/order",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "applyAction",
            Component: ApplyAction,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        // {
        //     path: "create",
        //     Component: Create,
        // },
    ],
    
}

export default Module;
